import { PaginatedPageProps } from "@/types/types"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { router, usePage } from "@inertiajs/react"
import { useDebounceCallback } from "usehooks-ts"

const SearchInput = () => {
  const { filters } = usePage<PaginatedPageProps>().props
  const initialSearch = filters?.search || ""

  const handleSearchChange = (newSearch: string) => {
    const query = new URLSearchParams(window.location.search)

    query.delete("page")

    if (newSearch.trim()) {
      query.set("search", newSearch)
    } else {
      query.delete("search")
    }

    if (newSearch === initialSearch) return

    router.get(window.location.pathname, Object.fromEntries(query.entries()), {
      preserveState: true,
      preserveScroll: true,
      replace: true,
    })
  }

  const debounced = useDebounceCallback(handleSearchChange, 400)

  return (
    <div className="w-full max-w-64">
      <label htmlFor="search" className="sr-only">
        Search
      </label>
      <div className="relative h-10 rounded-xl shadow-xs">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <MagnifyingGlassIcon
            className="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </div>
        <input
          type="text"
          id="search"
          name="search"
          className="focus:ring-chessdrop-600 block h-full w-full rounded-xl border-0 py-2 pl-10 text-sm text-gray-700 ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
          placeholder="Search..."
          defaultValue={initialSearch}
          onChange={(event) => debounced(event.target.value)}
        />
      </div>
    </div>
  )
}

export default SearchInput
